import React from "react";
import { IconButton } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { BookCheck } from "lucide-react";
import { CreateTemplateFromProgramDialog } from "../../dialog/CreateTemplateFromProgramDialog";
import { useCreateProgramTemplateMutation } from "../mutations/CreateProgramTemplate";
import { ProgramTemplateCategory } from "@growth-machine-llc/stridist-api-client";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.grey[200],
    borderRadius: theme.shape.borderRadius,
    padding: 7,

    [theme.breakpoints.up("md")]: {
      padding: 8,
    },
  },
}));

export interface CreateProgramTemplateButtonProps {
  programId: number;
  programName?: string;
}

export function CreateProgramTemplateButton({
  programId,
  programName,
}: CreateProgramTemplateButtonProps) {
  const s = useStyles();
  const [createTemplateDialogOpen, setCreateTemplateDialogOpen] =
    React.useState(false);

  const { mutate: createTemplate, isPending: isCreatingTemplate } =
    useCreateProgramTemplateMutation();

  const handleClick = React.useCallback(() => {
    setCreateTemplateDialogOpen(true);
  }, []);

  const handleDialogClose = React.useCallback(() => {
    setCreateTemplateDialogOpen(false);
  }, []);

  const handleDialogConfirm = React.useCallback(
    (name: string, category: ProgramTemplateCategory) => {
      createTemplate({
        programId,
        name,
        category,
      });
      setCreateTemplateDialogOpen(false);
    },
    [createTemplate, programId],
  );

  return (
    <>
      <IconButton
        className={s.root}
        children={<BookCheck />}
        onClick={handleClick}
        size="large"
      />
      <CreateTemplateFromProgramDialog
        open={createTemplateDialogOpen}
        onClose={handleDialogClose}
        programName={programName}
        onConfirm={handleDialogConfirm}
        isPending={isCreatingTemplate}
      />
    </>
  );
}
